import { securityModuleName } from '@pages/security/models/security-module-name';

export class SaveChangesModalTestIds {
  static submitButton = `${securityModuleName}-button-submit`;
  static cancelButton = `${securityModuleName}-button-cancel`;
}
